import React from 'react';

import { ArrowRight, Leaf, ShieldPlus, Factory, Recycle, Lightbulb } from 'lucide-react';

const SustainabilitySection = () => {

  return (
    <section className="py-16 px-4 bg-gray-50">
      <div className="container mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold text-[#364A9A] text-center mb-8 sm:mb-12 font-poppins">
          BUSINESS ACTIVITY
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16 items-stretch">
          {/* Left Column: Key Sustainability Metric/Statement */}
          <div className="bg-white rounded-lg shadow-lg p-6 sm:p-8 flex flex-col justify-center items-center text-center h-full">
            <div className="mb-6">
              {/* <p className="text-5xl md:text-6xl lg:text-8xl font-bold text-[#364A9A] leading-none">
                Business Activity
              </p> */}
              <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-main-blue mt-4">
                Specialty in Steel-Fabricated Elements and Structures
              </h3>
            </div>
            <p className="text-gray-700 text-base sm:text-lg leading-relaxed font-gilda max-w-md">
              The specialty of MK Metal & Engineering Works Sdn. Bhd. is different kinds of steel-fabricated elements and structures. Among them are important ones: Structural Steel Fabrication such as Load Bearing Steel Column, Beam.
              <br />
              Also Security gates, awnings, grilles, fencing around the premises, guard rails, stair hand rails, canopies, Steel Link Bridge, Bondek, and metal roofing etc are significant.
            </p>
          </div>

          {/* Right Column: Image and Icons */}
          <div className="bg-white rounded-lg shadow-lg p-6 sm:p-8 flex flex-col justify-center items-center h-full relative overflow-hidden">
            <img
              src="/hero_img/image-03.jpg" // Placeholder image for sustainability
              alt="Sustainability in action"
              className="w-full h-full object-cover absolute inset-0 rounded-lg"
            />
            <div className="absolute inset-0 bg-black/40 rounded-lg"></div> {/* Dark overlay */}
            <div className="relative z-10 flex flex-wrap justify-center gap-4 sm:gap-6 text-white">
              <div className="flex flex-col items-center">
                <Leaf size={36} className="text-[#ECEE07] mb-1 sm:mb-2" />
                <span className="text-sm sm:text-lg font-semibold">Eco-Friendly</span>
              </div>
              <div className="flex flex-col items-center">
                <ShieldPlus size={36} className="text-[#ECEE07] mb-1 sm:mb-2" />
                <span className="text-sm sm:text-lg font-semibold">Safety & Security</span>
              </div>
              <div className="flex flex-col items-center">
                <Lightbulb size={36} className="text-[#ECEE07] mb-1 sm:mb-2" />
                <span className="text-sm sm:text-lg font-semibold">Efficiency</span>
              </div>
            </div>
          </div>
        </div>
        </div>
    </section>
  );
};

export default SustainabilitySection;
